/* eslint-disable camelcase */
import axios from 'axios';
import { useFormik } from 'formik';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { ButtonGroup, Col, Container, Form, InputGroup, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import SlidingPane from "react-sliding-pane";
import * as Yup from 'yup';
import Button from '../../../../shared/components/Button';
import Select from '../../../../shared/components/Select';
import Switch from '../../../../shared/components/Switch/Switch';

const validationSchema = Yup.object().shape({
  reason: Yup.string().required()
});

/**
 *
 * @param {{
 * open: boolean
 * onRequestClose: func
 * }} params
 * @returns
 */
const SettingsMenu = ({
  history,
  open,
  onRequestClose,
  onAfterClose
}) => {
  const { t } = useTranslation();
  const offer = useSelector(store => get(store, 'offer.offer'));


  const [state, setState] = useState({
    reasons: [],
    loading: false,
    showCancel: false
  });

  const formik = useFormik({
    initialValues: {
      reason: null,
    },
    validationSchema,
    onSubmit: values => {
      setState({
        ...state,
        loading: true
      });
      axios.get(`/api/v1/influencers/offers/${offer.id}/user_offers/${offer.user_offer.id}/cancel`, {
        params: { offer_canceling_reason: values.reason }
      }).then(() => {
        setState({
          ...state,
          loading: false
        });
        onRequestClose(false);
        history.push('/');
      });
    }
  });

  const fetchReasons = async (e) => {
    setState({
      ...state,
      loading: true
    });
    let response = await axios.get('/api/v1/influencers/user_offers/canceled_reasons');
    let data_reasons = await response.data.user_offer_canceled_reasons;
    setState({
      ...state,
      reasons: data_reasons,
      showCancel: e,
      loading: false
    });
  };


  const CancelSelect = () =>
    <React.Fragment>
      <p className='text-1'>
        {t('influencers.pages.campaign.cancel_side_pane.reason_message')}
      </p>
      <Form.Group>
        <Form.Label>
          {t('influencers.pages.campaign.cancel_side_pane.reason_text')}
        </Form.Label>
        <Select
          className="mb-2"
          placeholder={t('influencers.pages.campaign.cancel_side_pane.reason')}
          name="reason"
          value={formik.values.reason}
          error={get(formik, 'touched.reason') && get(formik, 'errors.reason')}
          onChange={formik.handleChange}
          disabled={state.loading}
          options={
            state.reasons.map(reason => ({
              label: t(`influencers.pages.campaign.cancel_side_pane.${reason}`),
              value: reason
            }))
          }
        />
      </Form.Group>
    </React.Fragment>;

  const CancelFooter = () =>
    <React.Fragment>
      <hr className='my-6' />

      <Row className='justify-content-end'>
        <Col className="col-auto">
          <ButtonGroup className="non-adaptable">
            <Button
              variant="primary"
              type="button"
              onClick={() => onRequestClose(false)}>
              {t('influencers.pages.campaign.cancel_side_pane.close')}
            </Button>
          </ButtonGroup>
        </Col>
      </Row>
    </React.Fragment>;

  return (
    <SlidingPane
      overlayClassName="slide-over"
      isOpen={open}
      closeIcon={null}
      width="375"
      shouldCloseOnEsc
      onRequestClose={() => onRequestClose(false)}
      onAfterClose={onAfterClose}
      hideHeader
      from={document.body.dir === 'ltr' ? 'right' : 'left'}
    >
      { get(offer, 'show_seeding_cancel_warning', false) ? 
      <p style={{color: 'red'}}>
        {t('influencers.pages.campaign.apply_side_pane.cancelation_warning')}
      </p> :
      <Form onSubmit={formik.handleSubmit}>
        <h3 className='mb-4-5'>
          {t('influencers.pages.campaign.settings')}
        </h3>
        <Container>
          <Row>
            <p className='text-3'>
              {t('influencers.pages.campaign.cancel_side_pane.question')}
            </p>
          </Row>
          <Row className="align-items-center">
            <InputGroup>
              <Switch
                name="quitCampaign"
                onChange={fetchReasons}
                checked={state.showCancel}
                disabled={false}
              />
              <Form.Label>
                {t('influencers.pages.campaign.cancel_side_pane.toogle_button')}
              </Form.Label>
            </InputGroup>
          </Row>

          {!state.showCancel &&
            <Row id='cancelMessage'>
              <div className="text-1">
                {t('influencers.pages.campaign.cancel_side_pane.message')}
              </div>
            </Row>
          }
        </Container>
        {state.showCancel && state.reasons &&
          <CancelSelect></CancelSelect>
        }

        {state.showCancel && state.reasons &&
          <Button
            variant="secondary"
            type="submit"
            disabled={state.loading || !formik.values.reason}>
            {t('influencers.pages.campaign.cancel_side_pane.quit_button')}
          </Button>
        }

      </Form> }
      <CancelFooter></CancelFooter>
    </SlidingPane>
  );
};

SettingsMenu.propTypes = {
  history: PropTypes.any,
  open: PropTypes.bool,
  onRequestClose: PropTypes.func.isRequired,
  onAfterClose: PropTypes.func,
};

SettingsMenu.defaultProps = {
  history: null,
  open: false,
  onAfterClose: () => { }
};

export default withRouter(SettingsMenu);
